import { MessageCircleWarning } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { WhyItMattersProps } from './WhyItMatters.types';

export const WhyItMatters = ({ data }: WhyItMattersProps) => {
  const { t } = useTranslation('analysis');

  const panelTitle = data.brandInfo?.brandName
    ? t('socialMediaOpportunitiesWidget.whyItMatters.whyItMattersFor', {
        brandName: data.brandInfo.brandName,
      })
    : t('socialMediaOpportunitiesWidget.whyItMatters.whyItMatters');

  return (
    <div className="full-height bg-card rounded-lg p-6 border border-border-light">
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center w-8 h-8 rounded-sm bg-surface">
          <MessageCircleWarning size={16} />
        </div>
        <p className="text-base text-foreground font-medium">{panelTitle}</p>
      </div>

      {data.insightReasonings.length > 0 &&
        data.insightReasonings.slice(0, 1).map((reasoning, index) => {
          return (
            <p className="text-base text-foreground-alt mt-6" key={index}>
              {reasoning.description}
            </p>
          );
        })}
    </div>
  );
};
